var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loading', 'loading--' + _vm.type]},[_c('img',{staticClass:"loading__svg",attrs:{"src":require("@/assets/images/ui/loading.svg"),"width":_vm.size}})])}
var staticRenderFns = []

export { render, staticRenderFns }